var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({width:_vm.w,height:_vm.h}),on:{"touchmove":function($event){$event.preventDefault();}}},[_c('canvas',{ref:"canvas",staticClass:"canvas",attrs:{"disabled":_vm.disabled},on:{"mouseup":function($event){return _vm.save()},"touchend":function($event){return _vm.save()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }